// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2MvL0","choiceBoxes":"toolbarselects_choiceBoxes__27Nt0","simpleField":"toolbarselects_simpleField__18hlN"};